import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal, Row, Col, Divider } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as SocioService from 'services/socio.service'

import FileFormGroup from './formGroups/file'

const ImportarRegistrosModal = ({ handleClose, show, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)
  const formInitialValues = React.useMemo(
    () => ({
      file: ''
    }),
    []
  )

  const submitHandler = data => {
    __zariContext.loader.open('Importando registros')

    const submitData = new FormData()
    submitData.append('file', data.file)

    SocioService.importarExcelSocios(submitData)
      .then(() => {
        __zariContext.snack('success', `Los datos se han importado correctamente`)
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }

  const clickDescargarPlantilla = React.useCallback(() => {
    SocioService.descargarPlantillaImportarSocios().then(({ data, headers }) => {
      DownloadAxiosFile.downloadAsBlob(data, headers, 'Importar socios.xlsx')
    })
  }, [])

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>IMPORTAR EXCEL</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  <Button outline block onClick={clickDescargarPlantilla}>
                    Descargar plantilla
                  </Button>
                </Col>
              </Row>
              <Divider />
              <FileFormGroup
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                iError={errors.file}
                iTouched={touched.file}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Importar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default ImportarRegistrosModal
